"use client";

import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { useModal } from "./context/ModalContext";
import WebAppNavbar from "./components/WebAppNavbar";
import CartDrawer from "./components/CartDrawer";
import { PopulatedCartItem } from "./types/cart.types";
import ExpandedCardView from "./components/ProductCard/Expandable";

import ProductGrid from "./components/ProductsGrid";
import CategoryCarousel from "./components/CategoryCarousel";
import WholesalePopup from "./components/WholesalePopup";
import { useAuth } from "./context/AuthContext";

export default function HomePage() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { viewingItem, openProductModal, closeProductModal } = useModal();
  const { openAuthModal } = useAuth();

  useEffect(() => {
    if (viewingItem || isCartOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [viewingItem, isCartOpen]);

  const handleEditItem = (item: PopulatedCartItem) => {
    setIsCartOpen(false); // Close cart drawer
    openProductModal(item); // Open product modal with item data
  };

  return (
    <div>
      <WebAppNavbar onCartClick={() => setIsCartOpen(true)} />

      {process.env.NEXT_PUBLIC_ENABLE_WHOLESALE === 'true' && (
        <WholesalePopup onSelectWholesale={openAuthModal} />
      )}

      <AnimatePresence>
        {isCartOpen && (
          <CartDrawer
            onClose={() => setIsCartOpen(false)}
            onEditItem={handleEditItem}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {viewingItem && (
          <ExpandedCardView
            //eslint-disable-next-line
            key={(viewingItem as any)._id}
            product={
              "product" in viewingItem ? viewingItem.product : viewingItem
            }
            cartItemToEdit={"product" in viewingItem ? viewingItem : null}
            onClose={closeProductModal}
          />
        )}
      </AnimatePresence>

      <main className="pt-20">
        {}
        <CategoryCarousel />
        <ProductGrid />
      </main>
    </div>
  );
}
